import GlobalModal from '@components/GlobalModal';
import ModalTitle from '@components/modal/ModalTitle';
import { Access } from '@features/authorization';
import { Trans, msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Button, DialogActions, DialogContent, Skeleton } from '@mui/material';
import { FormEventHandler, type FC } from 'react';

interface Props {
  onClose: () => void;
  deviceId: string;
  disableConfirmation: () => void;
}

const Component: FC<Props> = ({ onClose, deviceId, disableConfirmation }) => {

  const onSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    disableConfirmation();
  };

  return (
    <form onSubmit={onSubmit}>
      <DialogContent dividers>
        <Trans>
          ¿Estás seguro que deseas desactivar los envíos DGA para el dispositivo {deviceId}?
        </Trans>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="info" onClick={onClose}>
          <Trans>Cancelar</Trans>
        </Button>
        <Button
          variant="contained"
          color="error"
          type='submit'
        >
          <Trans>Confirmar</Trans>
        </Button>
      </DialogActions>
    </form>
  );
};

const Fallback: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { _ } = useLingui();
  return (
    <DialogContent dividers>
      <ModalTitle title={_(msg`Desactivar envíos DGA`)} onClose={onClose} />
      <Skeleton height={100} variant="rounded" />
    </DialogContent>
  );
};

const DisableDGAConfigurationModal: FC<{
  open: boolean,
  deviceId: string,
  onClose: () => void,
  disableConfirmation: () => void,
}> = ({
  open,
  deviceId,
  onClose,
  disableConfirmation,
}) => {
    const { _ } = useLingui();

    return (
      <GlobalModal
        open={open}
        dialogProps={{ maxWidth: 'sm' }}
        authorization={{
          access: Access.UpdateDGAConfigurationsModal,
          deviceId: open ? deviceId : undefined,
          onClose,
        }}
        suspenseFallback={<Fallback onClose={onClose} />}
      >
        {open && (
          <>
            <ModalTitle title={_(msg`Desactivar envíos DGA`)} onClose={onClose} />
            <Component
              deviceId={deviceId}
              onClose={onClose}
              disableConfirmation={disableConfirmation}
            />
          </>
        )}
      </GlobalModal>
    );
  };

export default DisableDGAConfigurationModal;
